import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { addField, deleteField } from '../../actions/field-action';
import './style.css';


class DropdownField extends Component {
  onChange() {
    this.props.addField(this.props.fieldName, this.refs.select.value);
  }

  componentWillUnmount() {
    this.props.deleteField(this.props.fieldName);
  }

  render() {
    const optionList = this.props.optionList.map(option => (
      <option key={option.id} value={option.id}>{option.name}</option>
    ));
    if (this.props.defaultValue) {
      this.props.addField(this.props.fieldName, this.props.defaultValue);
    } else if (this.props.optionList.length !== 0){
      this.props.addField(this.props.fieldName, this.props.optionList[0].id);
    }
    return (
      <div className='field-dropdown'>
        <label className='field-dropdown__label'>{this.props.title}</label>
        <select
          ref='select' className='field-dropdown__field'
          key={this.props.fieldName} name={this.props.fieldName}
          defaultValue={this.props.defaultValue} onChange={this.onChange.bind(this)}
        >
          {optionList}
        </select>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  addField: bindActionCreators(addField, dispatch),
  deleteField: bindActionCreators(deleteField, dispatch)
});

export default connect(null, mapDispatchToProps)(DropdownField);


// WEBPACK FOOTER //
// ./src/blocks/dropdown-field/DropdownField.js